import { useAuth0 } from "@auth0/auth0-react";

import { Button } from "@/components/buttons";

import { ErrorPage } from "./ErrorPage";

export const FourOhOne = () => {
  const { logout } = useAuth0();
  return (
    <ErrorPage title="Accès refusé au back-office">
      <div tw="py-2">
        <Button
          red
          onClick={() =>
            logout({ logoutParams: { returnTo: window.location.origin } })
          }
          tw="w-fit"
        >
          Se déconnecter
        </Button>
      </div>
    </ErrorPage>
  );
};
